import { useState } from 'react';

import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementBrandItem } from '@/pages/menu-managements/items/service';

import { MenuManagementBrandItemService } from '../../MenuManagementItemService';

export type PreviewBulkUpsertBrandItemsResponse = {
  brand_items: MenuManagementBrandItem[];
  errors_by_line: { [line: string]: string[] };
  insert_count: number;
  update_count: number;
};

type Parameters = { associateBrandId: string; file: File };

const useMenuManagementPreviewBulkUpsertBrandItems = (): {
  loading: boolean;
  preview: (
    params: Parameters
  ) => Promise<PreviewBulkUpsertBrandItemsResponse | undefined>;
} => {
  const [loading, setLoading] = useState(false);
  const preview = async (params: Parameters) => {
    try {
      setLoading(true);
      const menuManagementBrandItemService = new MenuManagementBrandItemService(
        getClient()
      );
      return await menuManagementBrandItemService.previewBulkUpsert(params);
    } catch (error) {
      errorHandler({ error: error as Error });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    preview,
  };
};

export default useMenuManagementPreviewBulkUpsertBrandItems;
